import paymentInstructionCallouts from './paymentInstructionCallouts.json';

export { paymentInstructionCallouts };
export default paymentInstructionCallouts;
